import { Component } from '@angular/core';
import { AuthAndACLService } from './auth_and_acl/authAndACL.service';
import { APP_VERSION } from './constante';

import {AuthService} from "./auth/auth.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [AuthAndACLService]
})
export class AppComponent {
  title: string
  nome: string
  version: string
  email: string
  login: string
  perfis: string

  constructor(private authAndACL: AuthAndACLService, private route: Router) {
    this.title = 'CDHFM';
    this.version = APP_VERSION;
    this.email = "";
    this.login = "";
    this.perfis = "";
    if (this.islogged()) {
      var usuario = this.authAndACL.getUserData();

      this.nome = usuario.nome;

      usuario.perfis.forEach(perfil => {
        //console.log('perfil');
        //console.log(perfil);

        //console.log("regras");

        if (this.perfis == "") {
          this.perfis += perfil.nome;
        }
        else {
          this.perfis = this.perfis + ", " + perfil.nome;
        }

        if(usuario.perfis.length > 1){
          this.perfis + " - ";
        }

      });

    }
  }

  islogged() {
      /*
	  this.email = this.AuthService.getUsuario().email;
      this.login = this.AuthService.getUsuario().login;
      this.perfil = this.AuthService.getUsuario().perfil;

      if (this.login) {
          return true
      } else
          return false;
		*/
		return this.authAndACL.logado();
    }

  sair() {
        /*
		window.sessionStorage.setItem('email', ""),
        window.sessionStorage.setItem('login', ""),
        window.sessionStorage.setItem('perfil', ""),
        this.route.navigateByUrl("inicio");
		*/
		return this.authAndACL.logout();
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts